import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '', children: [
      {
        path: '',
        loadComponent: () => import('./what-we-do.component').then(m => m.WhatWeDoComponent),
        data: {
          title: 'KudosHub | What We Do',
          description:'We deliver effective IT solutions that help you connect with your audience in an enhanced way through meaningful customer touchpoints.',
          keywords: 'email marketing, web development, mobile development, email list cleaning',
          ogTitle: 'KudosHub | What We Do',
          ogDesc: 'We deliver effective IT solutions that help you connect with your audience in an enhanced way through meaningful customer touchpoints.',
          ogImage: 'https://kudoshub.com/theme/images/og-images/email-validation-service.webp',
          ogUrl: 'https://kudoshub.com/what-we-do',
          twitterTitle: 'KudosHub | What We Do',
          twitterDesc: 'We deliver effective IT solutions that help you connect with your audience in an enhanced way through meaningful customer touchpoints.',
          twitterImage: 'https://kudoshub.com/theme/images/og-images/email-validation-service.webp'
          }
      }
    ]
  }
];
